import {getElementMeasure} from "@fd/helpers/DomUtils";
import type {Anchor, Menu, MenuItem, MenuItemWithChildren} from "@/types/ui/Menu";
import {ExecuteItem, NavigateItem, SelectableMenuItem, SeparatorItem} from "@/types/ui/Menu";
import {InjectionKey} from "vue";

export interface Pin {
	x: number;
	y: number;
}

export type SelectFunc = (mi:MenuItem) => any;

export const selectKey = Symbol() as InjectionKey<SelectFunc>;


export function calcPin(elm:HTMLElement, pin:Anchor|undefined):Pin {
	if (elm) {
		const m = getElementMeasure(elm);
		let x = m.viewLeft;
		let y = m.viewTop;
		if (pin == null) pin = "left-bottom";
		switch (pin) {
			case "left-top":
				break;
			case "right-top":
				x += m.width;
				break;
			case "right-bottom":
				x += m.width;
				y += m.height;
				break;
			default:
			case "left-bottom":
				y += m.height;
				break;
		}
		return { x, y };
	}
	return { x: 0, y: 0 };
}


export function isMenu(mi:MenuItem): mi is Menu {
	return mi.type === "menu";
}

export function isNavigation(mi:MenuItem): mi is NavigateItem {
	return mi.type === "nav";
}

export function isAction(mi:MenuItem): mi is ExecuteItem {
	return mi.type === "action";
}

export function isSeparator(mi:MenuItem): mi is SeparatorItem {
	return mi.type === "separator";
}

export function isSelectable(mi:MenuItem): mi is SelectableMenuItem {
	return mi.type !== "separator";
}

export function setOpen(m: MenuItemWithChildren, open: boolean) {
	m.open = open;
	for (let mi of m.children) {
		if (isMenu(mi)) {
			setOpen(mi, false);
		}
	}
}

export function unselect(m: MenuItemWithChildren) {
	for (let mi of m.children) {
		if (isSelectable(mi)) {
			mi.select = "";
		}
		if (isMenu(mi)) {
			unselect(mi);
		}
	}
}
